export const filterFeatureKey = 'filters';
export const mpuFilterType = 'mpus';
export const filtersButtonTestID = 'filters-button';
export const filtersDebugTestID = 'filters-debug';
